import { EntityType, TabKeys } from 'UI/constants/entityTypes';

export const buildPresentationMakerCandidateParam = candidateData => {
  if (!candidateData || !candidateData?.id) return null;

  const { id, personalInformation, title, specialty, subspecialty } = candidateData || {};
  const { address } = personalInformation || {};

  return {
    candidate: {
      id,
      title,
      industry: specialty?.industry?.title,
      specialty: specialty?.title,
      subspecialty: subspecialty?.title,
      state: address?.city?.state?.title,
      city: address?.city?.title,
      postalCode: address?.zip
    }
  };
};

export const createTabsProps = ({
  blueSheet,
  candidate,
  candidateId,
  endpoint,
  handleRefreshActivityStatus,
  handleSendoutClick,
  handleWriteUpClick,
  isLoading,
  itemName,
  overviewProps,
  searchProjectsProps,
  tabKeys,
  triggerTabRefresh,
  uiState
}) => [
  {
    id: TabKeys.Overview,
    tabProps: {
      profile: candidate,
      onWriteUpClick: handleWriteUpClick,
      blueSheet,
      ...overviewProps
    }
  },
  {
    id: TabKeys.JobOrders,
    tabProps: {
      profileId: candidate?.id,
      isLoading,
      itemName,
      mode: EntityType.Candidate,
      endpoint
    }
  },
  {
    id: TabKeys.Sendouts,
    tabProps: {
      profile: candidate,
      profileModule: EntityType.Candidate,
      onSendoutClick: handleSendoutClick,
      shouldRefresh: uiState.shouldRefreshTableData
    }
  },
  {
    id: TabKeys.Placements,
    tabProps: {
      profileId: candidateId,
      key: tabKeys.placements,
      search: false,
      profileModule: EntityType.Candidate,
      isLoading,
      onTriggerTabRefresh: () => triggerTabRefresh(TabKeys.Placements)
    }
  },
  searchProjectsProps,
  {
    id: TabKeys.ActivityLogs,
    tabProps: {
      itemName,
      onActivityComplete: handleRefreshActivityStatus,
      profileId: candidate?.id,
      profileModule: EntityType.Candidate,
      endpoint
    }
  },
  {
    id: TabKeys.Notes,
    tabProps: {
      onActivityComplete: handleRefreshActivityStatus,
      type: 'notes',
      profileId: candidate?.id,
      itemName,
      search: false,
      endpoint,
      profileModule: EntityType.Candidate
    }
  },
  {
    id: TabKeys.ReferenceCheck,
    tabProps: {
      candidateId,
      candidateName: itemName ?? '',
      recruiter: candidate?.recruiter,
      additionalRecruiters: candidate?.additionalRecruiters
    }
  },
  {
    id: TabKeys.Tasks,
    tabProps: {
      itemName,
      profileId: candidateId
    }
  },
  {
    id: TabKeys.ResumeViewer,
    tabProps: {
      candidateId
    }
  },
  {
    id: TabKeys.MatchMaking,
    tabProps: {
      profileId: candidateId
    }
  }
];
